import { jsx as _jsx } from "react/jsx-runtime";
//@ts-ignore
import { Fade, Slide } from '@mui/material';
import './gentle-fade-transition.sass';
import { forwardRef } from 'react';
export const SlideUpTransition = forwardRef(function SlideUpTransition(props, ref) {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
export const FadeTransition = forwardRef(function FadeTransition(props, ref) {
    return _jsx(Fade, { timeout: 250, ref: ref, ...props });
});
